import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { CalcBoundaries } from "./CalcBoundaries";
import { CalcGeneralProps } from "./CalculationMain";
import { NumberInput } from "../framework/numberInput";

export const CalcDailyAllowance = ({
    translate,
    settings,
    setSettings,
}: CalcGeneralProps) => {
    const {
        dailyAllowanceBoundaries,
        isDailyAllowanceCostCenterIdOn,
        isDailyAllowanceVehicleIdOn,
        isIncreasedDailyAllowanceOn,
        increasedDailyAllowanceBoundary,
        isIncreasedDailyAllowanceBasedOnOvernightStay
    } = settings;

    const handleChange = (attr: string, value) => {
        setSettings({ ...settings, [attr]: value });
    };

    return (
        <Grid2 container direction="column" p={3}>
            <Grid2>
                <Typography variant="h3">
                    {translate("dailyAllowances")}
                </Typography>
            </Grid2>

            <Grid2>
                <CalcBoundaries
                    isOn={dailyAllowanceBoundaries.length > 0}
                    boundaries={dailyAllowanceBoundaries}
                    translate={translate}
                    fillBoundaries={(val) =>
                        handleChange("dailyAllowanceBoundaries", val)
                    }
                    default50={6}
                    default100={10}
                    label50={translate("partDailyAllowance")}
                    label100={translate("dailyAllowance")}
                />
            </Grid2>
            <Grid2>
                <Box sx={{ width: 200 }} mt={2}>
                    <Grid2
                        container
                        rowSpacing={2}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        alignItems="center"
                    >
                        <Grid2 xs={2}>
                            <Checkbox
                                id="isIncreasedDailyAllowanceOn"
                                checked={isIncreasedDailyAllowanceOn}
                                onClick={() =>
                                    handleChange(
                                        "isIncreasedDailyAllowanceOn",
                                        !isIncreasedDailyAllowanceOn
                                    )
                                }
                            />
                        </Grid2>
                        <Grid2 xs={10}>
                            <NumberInput
                                label={translate("hourBookingCategory.23")}
                                onChange={(value) =>
                                    handleChange(
                                        "increasedDailyAllowanceBoundary",
                                        value
                                    )
                                }
                                value={increasedDailyAllowanceBoundary}
                                endAdornment="h"
                            />
                        </Grid2>
                    </Grid2>
                </Box>
            </Grid2>
            {isIncreasedDailyAllowanceOn ? (
                <Grid2 mt={2}>
                    <label className={"field-width-normal"}>
                        <Checkbox
                            id="isIncreasedDailyAllowanceBasedOnOvernightStay"
                            checked={
                                isIncreasedDailyAllowanceBasedOnOvernightStay
                            }
                            onChange={(event) =>
                                handleChange(
                                    "isIncreasedDailyAllowanceBasedOnOvernightStay",
                                    event.target.checked
                                )
                            }
                        />
                        {translate(
                            "isIncreasedDailyAllowanceBasedOnOvernightStay"
                        )}
                    </label>
                </Grid2>
            ) : null}
            {isIncreasedDailyAllowanceOn ||
            dailyAllowanceBoundaries.length > 0 ? (
                <>
                    <Grid2 mt={2}>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="isDailyAllowanceCostCenterIdOn"
                                checked={isDailyAllowanceCostCenterIdOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isDailyAllowanceCostCenterIdOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("isDailyAllowanceCostCenterIdOn")}
                        </label>
                    </Grid2>
                    <Grid2 mt={2}>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="isDailyAllowanceVehicleIdOn"
                                checked={isDailyAllowanceVehicleIdOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isDailyAllowanceVehicleIdOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("isDailyAllowanceVehicleIdOn")}
                        </label>
                    </Grid2>
                </>
                ) : null}
        </Grid2>
    );
};
